module.exports = __webpack_public_path__ + "static/3500-front-view-feff4a361aadad63f5d92a6a81d1e54b.jpg";